/* eslint-disable no-unused-expressions */
/* eslint-disable eqeqeq */
// JavaScript source code
import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import CenteredSpinner from './CenteredSpinner';
import moment from 'moment-timezone';
import { useQuery } from 'react-query';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { AudioModal } from './modals/AudioModal';
import { numberWithCommas } from '../Utils';



export const RegisterClient = (props) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [zoneId, setZoneId] = useState('');
  const [locality, setLocality] = useState('');
  const [min, setMin] = useState('');
  const [max, setMax] = useState('');
  const [propertyTypeGroupId, setPropertyTypeGroupId] = useState('');
  const [propertyTypeId, setPropertyTypeId] = useState('');
  const [propertySubTypeId, setPropertySubTypeId] = useState('');
  const [propertyUse, setPropertyUse] = useState('false');
  const [forSale, setForSale] = useState('false');
  const [geoRegions, setGeoRegions] = useState('false');
  const navigate = useNavigate();
  const refPropertyTypeGroupId = useRef(null);
  const refPropertyTypeId = useRef(null);
  const refPropertySubTypeId = useRef(null);
  const [disabled, setDisabled] = useState(false);
  const refZoneId = useRef(null);
  const refLocalityId = useRef(null);
  const [geoRegionId, setGeoRegionId] = useState('');
  const [showRecorder, setShowRecorder] = useState(false);
  const [base64StringWavAudio, setBase64StringWavAudio] =
    useState(null);
  const [tokenFt, setTokenFt] = useState(
    localStorage.getItem('token'),
  );
  const [audioData, setAudioData] = useState(null);
  const [dataChunksAudio, setDataChunksAudio] = useState([]);
  const [recState, setRecState] = useState('');
  const [recStateMsg, setRecStateMsg] = useState('');
  const [activeSubmit, setActiveSubmit] = useState(false);
  const [timer, setTimer] = useState(0);
  const [duplicateBuyer, setDuplicateBuyer] = useState(null);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [skipDuplicateCheck, setSkipDuplicateCheck] = useState(false);
  const increment = useRef(null);
  const staffMemberId = localStorage.getItem('staffMemberId');
  const branchId = JSON.parse(localStorage.getItem('staffMemberInfo')).branchAccess[0]?.id;
  const departmentId = JSON.parse(localStorage.getItem('staffMemberInfo')).departmentId;

  useEffect(() => {
    let token = localStorage.getItem('token');
    setTokenFt(token);
    axios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${token}`;

    document.title = 'Register a Client';
    window.scrollTo(0, 0);
  }, []);

  const goBack = () => {
    navigate('/');
  };

  const handleMinBudgetChange = (event) => {
    setMin(event.target.value.trim());
  };

  const handleMaxBudgetChange = (event) => {
    setMax(event.target.value.trim());
  };

  const priceMinFocus = () => {
    if (min) {
      setMin(
        min
          .replace(/\.00$/, '')
          .replace(/[ ,.]/g, ' ')
          .replace(/ /g, ''),
      );
      return;
    }
    setMax(null);
  };

  const priceMaxFocus = () => {
    if (max) {
      setMax(
        max
          .replace(/\.00$/, '')
          .replace(/[ ,.]/g, ' ')
          .replace(/ /g, ''),
      );
      return;
    }
    setMax(null);
  };

  const handlePriceMinAutoComplete = () => {
    let priceMoney;
    if (min) {
      priceMoney = min
        .replace(/[ ,.]/g, '')
        .replace(/[K|k]/g, '*1000')
        .replace(/[M|m]/g, '*1000000')
        .replace(/[^0-9/*.]/g, '');

      var args = priceMoney.split('*');
      priceMoney = args.reduce((a, b) => a * b);
      let returnVal = numberWithCommas(priceMoney);
      setMin(returnVal);
      return;
    }
    setMin('');
  };

  const handlePriceMaxAutoComplete = () => {
    let priceMoney;
    if (max) {
      priceMoney = max
        .replace(/[ ,.]/g, '')
        .replace(/[K|k]/g, '*1000')
        .replace(/[M|m]/g, '*1000000')
        .replace(/[^0-9/*.]/g, '');

      var args = priceMoney.split('*');
      priceMoney = args.reduce((a, b) => a * b);
      let returnVal = numberWithCommas(priceMoney);
      setMax(returnVal);
      return;
    }
    setMax('');
  };

  useEffect(() => {
    setValues((values) => ({ ...values }));
  }, []);

  const validate = (values) => {
    let errors = {};
    let regExp =
      /\+356 123-4567-890|\+3561234567890|\+356123-4567-890/i;
    if (!values.firstname || values.firstname.trim() === '') {
      errors.name = 'Firstname is required';
    } else if (/\d/.test(values.name)) {
      errors.nameBoolean = true;
      errors.name = 'Firstname can not contain numbers';
      // eslint-disable-next-line eqeqeq
    } else if (values.firstname.length == 0) {
      errors.name = 'Firstname is invalid';
    }
    if (!values.surname || values.surname.trim() === '') {
      errors.surname = 'Surname is required';
    } else if (/\d/.test(values.surname)) {
      errors.surname = 'Surname can not contain numbers';
    }
    if (values.email?.length > 0 && !/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = 'Email address is invalid';
    }
    if (values.mobileNo?.length > 0 && values.mobileNo?.match(regExp)) {
      errors.mobileNo = 'Mobile Number is invalid';
    }
    if ((values.mobileNo == null && values.email == null) || (values.mobileNo?.length < 5 && values.email?.length < 5)) {
      toast.error(
        "Mobile Number or Email is required",
        {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        },
      );
      errors.email = 'Please input mobile or email';
      errors.mobileNo = 'Please input mobile or email';
    }
    if (max) {
      if (
        Number(min.replace(/[ ,.]/g, ' ').replace(/ /g, '')) >=
        Number(max.replace(/[ ,.]/g, ' ').replace(/ /g, ''))
      ) {
        errors.minmax = "Min can't be equal or greater than Max";
      }
    }
    if (!geoRegionId || geoRegionId == '') {
      errors.region = 'Region is required';
    }
    if (!zoneId || zoneId == '') {
      errors.zone = 'Zone is required';
    }
    if (!propertyTypeGroupId || propertyTypeGroupId == '') {
      errors.propertyTypeGroupId = 'Property Type Group is required';
    }
    return errors;
  };

  const postDataToAPI = useCallback(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      setDisabled(true);
      setActiveSubmit(true);

      const options = {
        method: 'POST',
        url: '/buyerspec',
        headers: {
          Accept: 'application/json',
        },
        data: {
          branchId: branchId,
          buyerLocalities: [
            {
              localityId: locality,
              streetId: null,
              zoneId: zoneId,
            },
          ],
          buyerPropertyTypes: [
            {
              priceFrom: !min
                ? 0
                : min
                    .replace(/\.00$/, '')
                    .replace(/[ ,.]/g, ' ')
                    .replace(/ /g, ''),
              priceFromFC: 0,
              priceTo: !max
                ? 0
                : max
                    .replace(/\.00$/, '')
                    .replace(/[ ,.]/g, ' ')
                    .replace(/ /g, ''),
              priceToFC: 0,
              propertyStateId: null,
              propertySubTypeId: propertySubTypeId,
              propertyTypeGroupId: propertyTypeGroupId,
              propertyTypeId: propertyTypeId,
            },
          ],
          buyerSpecName: `${values.firstname} ${values.surname}`,
          commercialOrResidential: propertyUse,
          currencyId: 1,
          email: values.email,
          geoRegionId: geoRegionId,
          inputBy: localStorage.getItem("username"),
          leaseRatePeriod: 'Monthly',
          lettingDate: '',
          lettingFwdDays: '',
          lettingMonths: '',
          negotiatorId: staffMemberId,
          phoneNo: values.mobileNo,
          preferredCurrencyRate: '',
          recStatusCode: 'P',
          saleOrLetting: forSale === 'false' ? false : true,
          status: 0, //Pending
          inputByDepartmentId: departmentId,
        },
      };

      return axios
        .request(options)
        .then(async (response) => {
          if (response.status === 201) {
            let ftc = response.data.buyerSpecRef.substring(0, 2);
            let ffc = response.data.buyerSpecRef.substring(0, 4);

            if (base64StringWavAudio) {
              var audioPath = `Buyer\\B${ftc}\\B${ffc}\\B${response.data.buyerSpecRef}\\O_${response.data.buyerSpecRef}`;

              var audioOptions = {
                method: 'POST',
                url: '/buyerspec/createanduploadbuyerextfile',
                headers: {
                  'Content-Type': 'application/json',
                },
                data: JSON.stringify({
                  Base64File: `${base64StringWavAudio}`,
                  MetaData: {
                    FileType: 3,
                    FileAccessId: 10,
                    Rating: 0,
                    SequenceNo: 1,
                    FileExtension: 'MP3',
                    FilePath: `${audioPath}`,
                    Description: `mobile upload of property audio of ${values.firstname} ${values.surname}`,
                  },
                  FileName: `${values.firstname}.mp3`,
                  PropertyRef: `${response.data.buyerSpecRef}`,
                }),
              };

              try {
                await axios(audioOptions);
              } catch (err) {}

              setActiveSubmit(false);
              setDisabled(false);
              setIsSubmitting(false);
              let message2 = `${values.firstname} ${values.surname}'s client has been added`;
              toast.success(`${message2}`, {
                position: 'top-center',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });

              const timer = setTimeout(() => {
                navigate('/');
              }, 2000);
              return () => clearTimeout(timer);
            }
            setDisabled(false);
            setIsSubmitting(false);
            toast.success(
              `${response.data.buyerSpecName} has been registered with Ref: ${response.data.buyerSpecRef}`,
              {
                position: 'top-center',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              },
            );
            const timer = setTimeout(() => {
              setIsSubmitting(false);
              navigate('/');
            }, 2000);
            return () => clearTimeout(timer);
          }
        })
        .catch(() => {
          setActiveSubmit(false);
          setDisabled(false);
          setIsSubmitting(false);
          toast.error(
            "Client wasn't saved due to server error, try again later",
            {
              position: 'top-left',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            },
          );
        });
    }
  }, [errors, isSubmitting, values]);

  useEffect(() => {
    postDataToAPI();
  }, [postDataToAPI]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const validationErrors = validate(values);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    if (!skipDuplicateCheck) {
      try {
        const response = await axios.post('/buyerspec/VerifyRepeatedBuyerSpec', buildBuyerSpecPayload());
        if (response.data && (response.data.phoneRepeated || response.data.emailRepeated)) {
          setDuplicateBuyer(response.data);
          setShowDuplicateModal(true);
          return;
        }
      } catch (error) {
        toast.error("Failed to verify buyer uniqueness", {
          position: 'top-center',
          autoClose: 3000,
        });
        return;
      }
    }

    setIsSubmitting(true); // Triggers postDataToAPI
  };


  const handleChange = (event) => {
    event.preventDefault();
    event.persist();
    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  const handlePropertyUseChange = (event) => {
    event.preventDefault();
    event.persist();
    setPropertyUse(event.target.dataset.user);

    if (event.target.dataset.user != propertyUse) {
      refPropertyTypeGroupId.current.state.value = null;
      refPropertyTypeId.current.state.value = null;
      refPropertySubTypeId.current.state.value = null;
      setPropertyUse(event.target.dataset.user);
    }
  };

  const handleForSaleChange = (event) => {
    event.preventDefault();
    event.persist();
    setForSale(event.target.dataset.user);
  };

  const handlePropertyTypeGroupChange = (event) => {
    refPropertyTypeId.current.state.value = null;
    refPropertySubTypeId.current.state.value = null;
    setPropertyTypeGroupId(event.value);
  };

  const handlePropertyTypeChange = (event) => {
    refPropertySubTypeId.current.state.value = null;
    setPropertyTypeId(event.value);
  };

  const handlePropertySubTypeChange = (event) => {
    setPropertySubTypeId(event.value);
  };

  const handleRegionChange = (event) => {
    refZoneId.current.state.value = null;
    setGeoRegionId(event.value);
  };

  const handleZoneChange = (event) => {
    refLocalityId.current.state.value = null;
    setZoneId(event.value);
  };

  const handleLocalityChange = (event) => {
    setLocality(event.value);
  };

  const postAudioMp3 = async (blob) => {
    const convertBlobToBase64 = async (blob) => {
      const base64StringWav = await blobToBase64(blob);
      return base64StringWav;
    };

    const blobToBase64 = (blob) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });

    let base64StringMp3 = await convertBlobToBase64(blob);
    setBase64StringWavAudio(base64StringMp3.split(',')[1]);
  };

  const fetchRegions = (geoRegions) => {
    const options = {
      method: 'GET',
      url: `lookuptoken/GetGeoRegionTokens`,
    };

    return axios
      .request(options)
      .then((response) => {
        let options = response.data.map((element) => {
          return {
            value: element.id,
            label: element.text
          };
        });
        return options;
      })
      .catch((error) => {});
  };

  const fetchZone = (geoRegionId) => {
    const options = {
      method: 'GET',
      url: `lookuptoken/GetZonesInRegionTokens`,
      params: { regionId: geoRegionId }
    };

    return axios
      .request(options)
      .then((response) => {
        let options = response.data.map((element) => {
          return {
            value: element.id,
            label: element.text,
            geoRegionId: geoRegionId,
          };
        });
        return options;
      })
      .catch((error) => {});
  };

  const fetchLocality = (zoneId) => {
    const options = {
      method: 'GET',
      url: `lookuptoken/GetLocalityInZoneTokens`,
      params: { zoneId }
    };

    return axios
      .request(options)
      .then((response) => {
        let options = response.data.map((element) => {
          return { value: element.id, label: element.text };
        });
        let any = {
          value: null,
          label: 'Any',
        };
        options.unshift(any);
        return options;
      })
      .catch((error) => {});
  };

  const fetchPropertyTypeGroup = (propertyUse) => {
    const options = {
      method: 'GET',
      url: `lookuptoken/GetPropertyTypeGroupsByIsCommercialTokens/${propertyUse}`,
    };

    return axios
      .request(options)
      .then(async (response) => {
        let options = await response.data.map((element) => {
          return { value: element.id, label: element.text };
        });
        //Sort results by label
        options.sort((a, b) => a.label.localeCompare(b.label));
        return options;
      })
      .catch((error) => {});
  };

  const fetchPropertyType = (propertyTypeGroupId) => {
    const options = {
      method: 'GET',
      url: `lookuptoken/GetPropertyTypesInGroupTokens`,
      params: { groupId: propertyTypeGroupId }
    };

    return axios
      .request(options)
      .then(async (response) => {
        let options = await response.data.map((element) => {
          return { value: element.id, label: element.text };
        });
        let any = {
          value: null,
          label: 'Any',
        };
        options.unshift(any);
        return options;
      })
      .catch((error) => {});
  };

  const fetchPropertySubType = (propertyTypeId) => {
    const options = {
      method: 'GET',
      url: `lookuptoken/GetPropertySubTypesInTypeTokens`,
      params: { typeId: propertyTypeId }
    };

    return axios
      .request(options)
      .then(async (response) => {
        let options = await response.data.map((element) => {
          return { value: element.id, label: element.text };
        });
        let any = {
          value: null,
          label: 'Any',
        };
        options.unshift(any);
        return options;
      })
      .catch((error) => {});
  };

  const { data: regionData } = useQuery(
    ['regionData', geoRegions],
    () => fetchRegions(geoRegions),
    {
      refetchOnWindowFocus: false,
    },
  );
  const { data: zoneData } = useQuery(
    ['zoneData', geoRegionId],
    () => fetchZone(geoRegionId),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(geoRegionId)
    },
  );
  const { data: LocalityData } = useQuery(
    ['LocalityData', zoneId],
    () => fetchLocality(zoneId),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(zoneId),
    },
  );
  const { data: PropertyTypeGroupData } = useQuery(
    ['PropertyTypeGroupData', propertyUse],
    () => fetchPropertyTypeGroup(propertyUse),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(propertyUse),
    },
  );
  const { data: PropertyTypeData } = useQuery(
    ['PropertyTypeData', propertyTypeGroupId],
    () => fetchPropertyType(propertyTypeGroupId),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(propertyTypeGroupId),
    },
  );
  const { data: PropertySubTypeData } = useQuery(
    ['PropertySubTypeData', propertyTypeId],
    () => fetchPropertySubType(propertyTypeId),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(propertyTypeId),
    },
  );

  const startWebAudioRecorder = async () => {
    setAudioData(null);
    function is_publish_supported() {
      return (
        navigator.mediaDevices &&
        navigator.mediaDevices.getUserMedia &&
        navigator.mediaDevices.enumerateDevices &&
        window.RTCPeerConnection &&
        window.RTCIceCandidate &&
        window.RTCSessionDescription
      );
    }

    console.log(
      'Unsupported debug - navigator.mediaDevices: ' +
        Boolean(navigator.mediaDevices),
    );
    console.log(
      'Unsupported debug - navigator.getUserMedia: ' +
        (Boolean(navigator.mediaDevices) &&
          Boolean(navigator.mediaDevices.getUserMedia)),
    );
    console.log(
      'Unsupported debug - navigator.enumerateDevices: ' +
        (Boolean(navigator.mediaDevices) &&
          Boolean(navigator.mediaDevices.enumerateDevices)),
    );
    console.log(
      'Unsupported debug - navigator.RTCPeerConnection: ' +
        Boolean(window.RTCPeerConnection),
    );
    console.log(
      'Unsupported debug - navigator.RTCIceCandidate: ' +
        Boolean(window.RTCIceCandidate),
    );
    console.log(
      'Unsupported debug - navigator.RTCSessionDescription: ' +
        Boolean(window.RTCSessionDescription),
    );

    if (
      navigator.mediaDevices &&
      navigator.mediaDevices.getUserMedia
    ) {
      try {
        var stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          // video: false,
        });
      } catch (err) {
        if (
          err.name == 'NotFoundError' ||
          err.name == 'DevicesNotFoundError'
        ) {
          toast.error(
            'Microphone not detected.',
            {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            },
          );
          //required track is missing
        } else if (
          err.name == 'NotReadableError' ||
          err.name == 'TrackStartError'
        ) {
          toast.error('Mic are already in use', {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          //webcam or mic are already in use
        } else if (
          err.name == 'OverconstrainedError' ||
          err.name == 'ConstraintNotSatisfiedError'
        ) {
          toast.error(
            'The specified constraints resulted in no candidate devices which met the criteria requested.',
            {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            },
          );
          //constraints can not be satisfied by avb. devices
        } else if (
          err.name == 'NotAllowedError' ||
          err.name == 'PermissionDeniedError'
        ) {
          toast.error(
            'User denies (or has previously denied) access to the webcam or microphone',
            {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            },
          );
          //permission denied in browser
        } else if (
          err.name == 'TypeError' ||
          err.name == 'TypeError'
        ) {
          toast.error(
            'The constraints object passed to getUserMedia() is empty or has all tracks (audio, video or both) set to false',
            {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            },
          );
          //empty constraints object
        } else {
          toast.error('other errors', {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          //other errors
        }
      }

      // async function getConnectedDevices(type) {
      //   const devices =
      //     await navigator.mediaDevices.enumerateDevices();
      //   return devices.filter((device) => device.kind === type);
      // }

      // const videoCameras = getConnectedDevices('audiooutput');
      // videoCameras.then((res) => console.log(res));

      // async function getConnectedDevicesAll() {
      //   const devices =
      //     await navigator.mediaDevices.enumerateDevices();
      //   return devices;
      // }

      // const allDevices = getConnectedDevicesAll();
      // allDevices.then((res) => console.log(res));

      window.mediaRecorder = await new MediaRecorder(stream);
      window.mediaRecorder.start(100);

      clearInterval(increment.current);
      setTimer(0);

      if (
        'mediaRecorder' in window &&
        window.mediaRecorder.state === 'recording'
      ) {
        setRecState('recording');
        setRecStateMsg('recording...');
        increment.current = setInterval(() => {
          setTimer((timer) => timer + 1);
        }, 1000);
      }
    } else {
      toast.error('getUserMedia not supported on your browser!', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  useEffect(() => {
    let concatChunks = [];
    if (
      'mediaRecorder' in window &&
      window.mediaRecorder.state === 'recording'
    ) {
      var dataChunks = [];
      window.mediaRecorder.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) {
          dataChunks.push(e.data);
        }

        concatChunks = [...dataChunksAudio, ...dataChunks];

        setDataChunksAudio(concatChunks);
      };
    }
  }, [recState]);

  const buildBuyerSpecPayload = () => ({
    branchId,
    buyerLocalities: [{ localityId: locality, streetId: null, zoneId }],
    buyerPropertyTypes: [{
      priceFrom: !min ? 0 : min.replace(/[ ,.]/g, '').replace(/ /g, ''),
      priceFromFC: 0,
      priceTo: !max ? 0 : max.replace(/[ ,.]/g, '').replace(/ /g, ''),
      priceToFC: 0,
      propertyStateId: null,
      propertySubTypeId,
      propertyTypeGroupId,
      propertyTypeId,
    }],
    buyerSpecName: `${values.firstname} ${values.surname}`,
    commercialOrResidential: propertyUse,
    currencyId: 1,
    email: values.email,
    geoRegionId,
    inputBy: localStorage.getItem("username"),
    leaseRatePeriod: 'Monthly',
    lettingDate: '',
    lettingFwdDays: '',
    lettingMonths: '',
    negotiatorId: staffMemberId,
    phoneNo: values.mobileNo,
    preferredCurrencyRate: '',
    recStatusCode: 'P',
    saleOrLetting: forSale === 'false' ? false : true,
    status: 0,
    inputByDepartmentId: departmentId,
  });


  const stopWebAudioRecorder = () => {
    if (
      'mediaRecorder' in window &&
      (window.mediaRecorder.state === 'recording' ||
        window.mediaRecorder.state === 'paused')
    ) {
      setRecState('stopped');
      setRecStateMsg('stopped');
      window.mediaRecorder.stop();
      window.mediaRecorder.onstop = () => {
        let blob = new Blob(dataChunksAudio, { type: 'audio/mp3;' });
        let audioURL = window.URL.createObjectURL(blob);
        setAudioData(audioURL);
        postAudioMp3(blob);
      };

      clearInterval(increment.current);
    }
  };

  const pauseWebAudioRecorder = () => {
    if (
      'mediaRecorder' in window &&
      window.mediaRecorder.state === 'recording'
    ) {
      setRecState('paused');
      setRecStateMsg('paused');
      window.mediaRecorder.pause();
      clearInterval(increment.current);
    }
  };

  const resumeWebAudioRecorder = () => {
    if (
      'mediaRecorder' in window &&
      window.mediaRecorder.state === 'paused'
    ) {
      setRecState('resumeRecording');
      setRecStateMsg('resumed recording...');
      window.mediaRecorder.resume();
      increment.current = setInterval(() => {
        setTimer((timer) => timer + 1);
      }, 1000);
    }
  };

  const formatTime = () => {
    const getSeconds = `0${timer % 60}`.slice(-2);
    const minutes = `${Math.floor(timer / 60)}`;
    const getMinutes = `0${minutes % 60}`.slice(-2);
    const getHours = `0${Math.floor(timer / 3600)}`.slice(-2);

    return `${getHours} : ${getMinutes} : ${getSeconds}`;
  };

  const stopAndCloseAudio = () => {
    if (
      'mediaRecorder' in window &&
      (window.mediaRecorder.state === 'recording' ||
        window.mediaRecorder.state === 'paused')
    ) {
      window.mediaRecorder.stop();
      toast.success(`Recording stopped and audio deleted`, {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setAudioData(null);
      setRecState('');
      setDataChunksAudio([]);
      setRecStateMsg('');
      setBase64StringWavAudio('');
      clearInterval(increment.current);
      setTimer(0);
    }
  };

  if (activeSubmit) {
    return (
      <CenteredSpinner>
        <h3 className="text-center">
          Submitting the data,Please wait while we are processing your request!!
        </h3>
      </CenteredSpinner>
    );
  }

  return (
    <div className="container p-0 vh-100">
      <div className="row justify-content-center align-items-center ">
        <div className="col-9 col-md-9 col-xl-9">
          <div className="h4 mb-3 ml-0 font-weight-bold">
            New Client
          </div>
        </div>
        <div className="col-3 col-md-3 col-xl-3 text-right">
        <p className="btn btn-outline-secondary d-block mb-4" onClick={() => navigate(-1)}>
            <i className="fas fa-arrow-left me-2" style={{ color: '#6c757d' }}></i>
            Back
          </p>
        </div>
      </div>
      <div id="map"></div>
      <div className="row justify-content-center align-items-center ">
        <div className="col-12 col-md-12 col-xl-12">
          <form id="validation-form" noValidate="novalidate">
            <div className="form-group">
              <label className="form-label w-100" htmlFor="name">
                Client's Name:{' '}
              </label>
              <input
                autoComplete="on"
                className={`form-control ${
                  errors.name && 'border-danger'
                } d-block w-100 mb-2`}
                type="text"
                name="firstname"
                onChange={handleChange}
                value={values.firstname || ''}
                required
                placeholder="John"
                id="firstname"
              />
              {errors.name && (
                <small className="text-danger d-block">
                  {errors.name}
                </small>
              )}
              <label className="form-label mt-2 w-100">
                Client's Surname:{' '}
              </label>
              <input
                autoComplete="on"
                className={`form-control ${
                  errors.surname && 'border-danger'
                } d-block w-100 mb-2`}
                type="text"
                name="surname"
                onChange={handleChange}
                value={values.surname || ''}
                required
                placeholder="Doe"
              />
              {errors.surname && (
                <small className="text-danger d-block">
                  {errors.surname}
                </small>
              )}
              <label className="form-label mt-2 w-100">
                Client's Mobile No:
              </label>
              <div className="form-group d-flex justify-content-center align-items-center w-100 mb-2">
                <div className="w-100 col-3 p-0">
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control"
                    value="+356"
                    disabled
                    placeholder="Min"
                  />
                </div>
                <div className="w-100 col-9 p-0">
                  <input
                    autoComplete="on"
                    className={`form-control ${
                      errors.mobileNo && 'border-danger'
                    } d-block w-100`}
                    type="number"
                    name="mobileNo"
                    onChange={handleChange}
                    value={values.mobileNo || ''}
                  />
                </div>
              </div>
              {errors.mobileNo && (
                <small className="text-danger d-block">
                  {errors.mobileNo}
                </small>
              )}
              <label className="form-label mt-2 w-100">
                Client's Email:{' '}
              </label>
              <input
                autoComplete="on"
                className={`form-control ${
                  errors.email && 'border-danger'
                } d-block w-100 mb-2`}
                type="text"
                name="email"
                onChange={handleChange}
                value={values.email || ''}
                placeholder="John.Doe@gmail.com"
              />
              {errors.email && (
                <small className="text-danger d-block">
                  {errors.email}
                </small>
              )}
              <label className="form-label mt-2 w-100">
                Property For Sale/To-Let:{' '}
              </label>
              <div>
                <div
                  className={`button-belair w-50 ${
                    forSale === 'false' ? 'blend' : ''
                  }`}
                  onClick={handleForSaleChange}
                  data-user="false"
                >
                  For-Sale
                </div>
                <div
                  className={`button-belair w-50 ${
                    forSale === 'true' ? 'blend' : ''
                  }`}
                  onClick={handleForSaleChange}
                  data-user="true"
                >
                  To-Let
                </div>
              </div>

              <div className="mt-4">
                <label className="form-label w-100">Budget:</label>
                <div className="form-group d-flex justify-content-center align-items-center mb-2">
                  <div className="w-100 col-6 p-0">
                    <div className="col-12 p-0">
                      <input
                        type="text"
                        autoComplete="off"
                        className={`form-control ${
                          errors.minmax && 'border-danger'
                        } d-block w-100`}
                        value={min}
                        onChange={handleMinBudgetChange}
                        onBlur={handlePriceMinAutoComplete}
                        onFocus={priceMinFocus}
                        placeholder="Min"
                      />
                    </div>
                  </div>
                  <div className="w-100 col-6 p-0">
                    <div className="col-12 p-0">
                      <input
                        type="text"
                        autoComplete="off"
                        className={`form-control ${
                          errors.minmax && 'border-danger'
                        } d-block w-100`}
                        value={max}
                        onChange={handleMaxBudgetChange}
                        onBlur={handlePriceMaxAutoComplete}
                        onFocus={priceMaxFocus}
                        placeholder="Max"
                      />
                    </div>
                  </div>
                </div>
                {errors.minmax && (
                  <small className="text-danger d-block">
                    {errors.minmax}
                  </small>
                )}
              </div>

              <label className="form-label mt-2 w-100">Region: </label>
              <Select
                className={`${errors.zone && 'react-select'}`}
                classNamePrefix={`${errors.zone && 'react-select'}`}
                onChange={handleRegionChange}
                isSearchable={true}
                options={regionData}
              />
              {errors.region && (
                <small
                  className="form-text text-danger"
                  style={{ display: 'block' }}
                >
                  {errors.region}
                </small>
              )}

              <label className="form-label mt-2 w-100">Zone: </label>
              <Select
                className={`${errors.zone && 'react-select'}`}
                classNamePrefix={`${errors.zone && 'react-select'}`}
                onChange={handleZoneChange}
                ref={refZoneId}
                isSearchable={true}
                options={zoneData}
              />
              {errors.zone && (
                <small
                  className="form-text text-danger"
                  style={{ display: 'block' }}
                >
                  {errors.zone}
                </small>
              )}
              <label className="form-label mt-2 w-100">
                Locality:{' '}
              </label>
              <Select
                className={`${errors.locality && 'react-select'}`}
                classNamePrefix={`${
                  errors.locality && 'react-select'
                }`}
                onChange={handleLocalityChange}
                ref={refLocalityId}
                isSearchable={true}
                options={LocalityData}
              />
              {errors.locality && (
                <small className="form-text text-danger d-block">
                  {errors.locality}
                </small>
              )}

              <label className="form-label mt-2 w-100">
                Property Use:
              </label>
              <div>
                <div
                  className={`button-belair w-50 ${
                    propertyUse === 'false' ? 'blend' : ''
                  }`}
                  onClick={handlePropertyUseChange}
                  data-user="false"
                >
                  Residential
                </div>
                <div
                  className={`button-belair w-50 ${
                    propertyUse === 'true' ? 'blend' : ''
                  }`}
                  onClick={handlePropertyUseChange}
                  data-user="true"
                >
                  Commercial
                </div>
              </div>

              <label className="form-label mt-2 w-100">
                Property Type Group:{' '}
              </label>
              <Select
                className={`${
                  errors.propertyTypeGroupId && 'react-select'
                }`}
                classNamePrefix={`${
                  errors.propertyTypeGroupId && 'react-select'
                }`}
                onChange={handlePropertyTypeGroupChange}
                ref={refPropertyTypeGroupId}
                isSearchable={true}
                options={PropertyTypeGroupData}
              />
              {errors.propertyTypeGroupId && (
                <small className="form-text text-danger d-block">
                  {errors.propertyTypeGroupId}
                </small>
              )}
              <label className="form-label mt-2 w-100">
                Property Type:{' '}
              </label>
              <Select
                onChange={handlePropertyTypeChange}
                ref={refPropertyTypeId}
                isSearchable={true}
                options={PropertyTypeData}
              />
              <label className="form-label mt-2">
                Property Sub-Type:{' '}
              </label>

              <Select
                onChange={handlePropertySubTypeChange}
                ref={refPropertySubTypeId}
                isSearchable={true}
                options={PropertySubTypeData}
              />
            </div>
            <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
              <p
                className="btn btn-outline-secondary d-block mb-0"
                onClick={goBack}
              >
                <i className="fas fa-arrow-left me-2" style={{ color: '#6c757d' }}></i>
                Back
              </p>
              <div
                className="cursor-item"
                onClick={() => setShowRecorder(true)}
              >
                <i className="fas fa-microphone-alt fa-2x"></i>
              </div>
              <button
                type="submit"
                onClick={handleSubmit}
                className={
                  values.name !== '' &&
                  values.surname !== '' &&
                  values.email !== '' &&
                  values.mobileNo !== '' &&
                  zoneId !== '' &&
                  locality !== '' &&
                  propertyTypeGroupId !== '' &&
                  disabled === true
                    ? 'btn btn-success'
                    : 'btn btn-primary'
                }
                disabled={
                  values.name !== '' &&
                  values.surname !== '' &&
                  values.email !== '' &&
                  values.mobileNo !== '' &&
                  zoneId !== '' &&
                  locality !== '' &&
                  propertyTypeGroupId !== '' &&
                  disabled === true
                }
              >
                {values.name !== '' &&
                values.surname !== '' &&
                values.email !== '' &&
                values.mobileNo !== '' &&
                zoneId !== '' &&
                locality !== '' &&
                propertyTypeGroupId !== '' &&
                disabled === true
                  ? 'Submitting...'
                  : 'Submit'}
              </button>
            </div>
          </form>
          {showDuplicateModal && duplicateBuyer && (
            <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title"><strong>Duplicate Buyer Detected</strong></h5>
                    <button type="button" className="close" onClick={() => setShowDuplicateModal(false)}>
                      <span>&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <p><strong>Phone:</strong> {duplicateBuyer.phoneRepeated || 'N/A'}</p>
                    <p><strong>Email:</strong> {duplicateBuyer.emailRepeated || 'N/A'}</p>
                    <p><strong>Reference:</strong> {duplicateBuyer.addressRef}</p>
                    <p><strong>Negotiator:</strong> {duplicateBuyer.staffMemberName}</p>
                    <p><strong>Registered:</strong> {moment(duplicateBuyer.addressGdprOptInDate).format('DD/MM/YYYY')}</p>
                    <p>Would you like to proceed anyway?</p>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        setShowDuplicateModal(false);
                        setDuplicateBuyer(null);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        setShowDuplicateModal(false);
                        setSkipDuplicateCheck(true);
                        setIsSubmitting(true);
                      }}
                    >
                      Proceed Anyway
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <AudioModal
            showRecorder={showRecorder}
            setShowRecorder={setShowRecorder}
            stopAndCloseAudio={stopAndCloseAudio}
            audioData={audioData}
            recStateMsg={recStateMsg}
            formatTime={formatTime}
            startWebAudioRecorder={startWebAudioRecorder}
            pauseWebAudioRecorder={pauseWebAudioRecorder}
            resumeWebAudioRecorder={resumeWebAudioRecorder}
            stopWebAudioRecorder={stopWebAudioRecorder}
            increment={increment}
            recState={recState}
            setAudioData={setAudioData}
            setRecState={setRecState}
            setDataChunksAudio={setDataChunksAudio}
            setBase64StringWavAudio={setBase64StringWavAudio}
            clearInterval={clearInterval}
            setTimer={setTimer}
            setRecStateMsg={setRecStateMsg}
          />
        </div>
      </div>
    </div>
  );
};
